/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  ExpansionPanel,
  TableRow,
  TableCell,
  Avatar,
  Button,
} from '@material-ui/core';
import { orange, red, blue, green, grey } from '@material-ui/core/colors';
import { IconButton, Tooltip } from '@material-ui/core/index';
import DeleteIcon from '@material-ui/icons/Delete';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import TrackingCourier from './TrackingCourier';
import TrackingNumber from './TrackingNumber';
import DollorsInput from './DollorsInput';
import { valueFormat } from '../common/constants';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: '0 5px',
    paddingRight: 5,
  },
  body: {
    fontSize: 14,
    padding: '0 5px',
  },
}))(TableCell);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 50,
  },
  table: {
    width: '100%',
  },

  tableInSide: {
    width: '100%',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 150,
  },
  tableCell: {
    padding: '4px',
  },

  tableCellInside: {
    border: 0,
  },
  panel: {
    margin: 5,
    padding: 5,
    border: 1,
  },
  button: {
    margin: theme.spacing.unit,
    color: '#4e91fd',
  },
  avatarRed: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: red[500],
    float: 'left',
  },
  avatarOrange: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: orange[500],
    float: 'left',
  },
  avatarBlue: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: blue[500],
    float: 'left',
  },
  avatarGreen: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: green[500],
    float: 'left',
  },
  avatarGrey: {
    marginLeft: 10,
    color: '#fff',
    backgroundColor: grey[500],
  },
});

class OrderCellMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    // this.handleCloseDetails = this.handleCloseDetails.bind(this);
    // this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick = orderId => {
    this.setState({ currentOrderId: orderId });
  };

  getStatusLabel = (order, item, classes) => (
    <Avatar
      className={
        order[item.id] === 'late'
          ? classes.avatarRed
          : order[item.id] === 'today'
            ? classes.avatarOrange
            : order[item.id] === 'coming'
              ? classes.avatarBlue
              : order[item.id] === 'sent' || order[item.id] === 'Sent'
                ? classes.avatarGreen
                : order[item.id] === 'cancelled'
                  ? classes.avatarGrey
                  : ''
      }
    >
      {order[item.id] === 'late'
        ? 'L'
        : order[item.id] === 'today'
          ? 'T'
          : order[item.id] === 'coming'
            ? 'N'
            : order[item.id] === 'sent' || order[item.id] === 'Sent'
              ? 'S'
              : order[item.id] === 'cancelled'
                ? 'C'
                : ''}
    </Avatar>
  );

  getButtons = (order, removeTracking, splitShipment, classes) => (
    <div>
      <Tooltip title="Split shipment">
        <IconButton
          onClick={() => splitShipment(order)}
          className={classes.button}
          disabled={order.products.length < 2 || order.shippingStatusLabel === 'cancelled'}
          aria-label="Split"
        >
          <CallSplitIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Remove tracking">
        <IconButton
          onClick={() => this.props.handleOpenDelete(order.orderid, order.shipmentRef)}
          className={classes.deleteButton}
          aria-label="Delete"
          disabled={
            (!order.trackingNumber && !order.courier) || order.shippingStatusLabel === 'cancelled'
          }
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  );

  render() {
    const {
      classes,
      handleOnClick,
      order,
      setTrackingNumber,
      setCourier,
      columnData,
      removeTracking,
      noButtons,
      splitShipment,
      setShipmentCost,
      carriers
    } = this.props;

    return (
      <ExpansionPanel expanded className={classes.panel} style={{ marginBottom: '5px' }}>
        <Table className={classes.table}>
          <TableBody>
            {columnData.map(item => (
              <TableRow className={classes.row} key={order.id}>
                <CustomTableCell component="th" scope="row" key={`${order.id}_${item.id}`}>
                  {item.id === 'shippingStatusLabel'
                    ? this.getStatusLabel(order, item, classes)
                    : item.label}
                </CustomTableCell>
                <CustomTableCell numeric style={{ paddingRight: '5px' }} align="right">
                  {order[item.id] && typeof order[item.id] === 'object' ? (
                    order[item.id].map((arr, index) => (
                      <table className={classes.tableInSide}>
                        <TableRow>
                          <TableCell
                            className={classes.tableCellInside}
                            numeric
                            paddingNone
                            style={{
                              padding: '5px',
                              fontWeight:
                                item.id === 'quantity' ? (arr * 100 > 900 ? 900 : arr * 100) : 100,
                            }}
                          >
                            {arr}
                          </TableCell>
                        </TableRow>
                      </table>
                    ))
                  ) : item.id === 'shippingStatusLabel' ? (
                    !noButtons && this.getButtons(order, removeTracking, splitShipment, classes)
                  ) : item.id === 'trackingNumber' ? (
                    <TrackingNumber
                      setTrackingNumber={setTrackingNumber}
                      trackingNumber={order[item.id]}
                      order={order}
                    />
                  ) : item.id === 'courier' ? (
                    <TrackingCourier
                      setCourier={setCourier}
                      trackingCourier={order[item.id]}
                      order={order}
                      carriers={carriers}
                    />
                  ) : item.id === 'supplierInputCost' ? (
                    <DollorsInput
                      setShipmentCost={setShipmentCost}
                      cost={order[item.id]}
                      order={order}
                    />
                  ) : item.isLink ? (
                    <Button
                      color="primary"
                      className={classes.button}
                      onClick={() => {
                        handleOnClick(order);
                      }}
                    >
                      {order[item.id]}
                    </Button>
                  ) : (
                    valueFormat(item, order[item.id])
                  )}
                </CustomTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ExpansionPanel>
    );
  }
}

OrderCellMobile.propTypes = {
  classes: PropTypes.object.isRequired,
  setTrackingNumber: PropTypes.func,
  setCourier: PropTypes.func,
  handleOnClick: PropTypes.func,
  order: PropTypes.object.isRequired,
  columnData: PropTypes.object.isRequired,
  splitShipment: PropTypes.func,
  setShipmentCost: PropTypes.func,
  removeTracking: PropTypes.func,
  carriers: PropTypes.array,
};

export default withStyles(styles)(OrderCellMobile);



// WEBPACK FOOTER //
// ./src/components/orders/OrderCellMobile.js